import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({ standalone: false,
  selector: 'irb-file-selector',
  templateUrl: './file-selector.component.html',
  styleUrls: ['./file-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class FileSelectorComponent implements OnInit {
  file: any;
  @Input() width: number = 260;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Input() hideFileName = false;
  @Output() fileBrowsed: EventEmitter<any> = new EventEmitter();
  @Input() disabled = false;
  constructor() { }

  ngOnInit() {
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    // event.preventDefault();
    this.change.emit(event);
    this.fileBrowsed.emit(event);
  }
}
